import React from "react";
import Footer from "../../components/Footer";
import Manager from "./ManagerView";

export function ManagerContainer() {
  return (
    <div>
      <Manager title="Contact"/>
      <Footer/>
    </div>
  );
}
